import * as yup from 'yup'

export const addSubjectsSchema = yup.object({
	name: yup.string().required(),
})
